import { UserTeamsController } from '@features/user-teams';
import withMenuLayout from '@root/src/layout/withMenuLayout';

export const UserTeamsPage = withMenuLayout(UserTeamsController);
